// eslint-disable-next-line import/no-unassigned-import
import "./style/index.css";
import App from "./components/app";

export default App;
